import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "sonner";
import { CompareProvider } from "@/context/CompareContext";
import { AuthProvider, useAuth } from "@/context/AuthContext";
import { Header } from "@/components/Header";
import { Footer } from "@/components/Footer";
import HomePage from "@/pages/HomePage";
import DirectoryPage from "@/pages/DirectoryPage";
import ProgramDetailPage from "@/pages/ProgramDetailPage";
import ComparePage from "@/pages/ComparePage";
import NichesPage from "@/pages/NichesPage";
import NicheDetailPage from "@/pages/NicheDetailPage";
import BeginnersHubPage from "@/pages/BeginnersHubPage";
import CalculatorsPage from "@/pages/CalculatorsPage";
import AboutPage from "@/pages/AboutPage";
import AdminPage from "@/pages/AdminPage";
import AdcpPage from "@/pages/AdcpPage";
import GetFeaturedPage from "@/pages/GetFeaturedPage";
import PaymentSuccessPage from "@/pages/PaymentSuccessPage";
import PaymentCancelPage from "@/pages/PaymentCancelPage";
import RewardsPage from "@/pages/RewardsPage";
import LoginPage from "@/pages/LoginPage";
import SignupPage from "@/pages/SignupPage";
import DashboardPage from "@/pages/DashboardPage";
import RedirectPage from "@/pages/RedirectPage";
import AdsPage from "@/pages/AdsPage";
import TutorialsPage from "@/pages/TutorialsPage";
import LeaderboardPage from "@/pages/LeaderboardPage";
import OfficialLinksPage from "@/pages/OfficialLinksPage";
import OfficialLinkDetailPage from "@/pages/OfficialLinkDetailPage";
import VerifyEmailPage from "@/pages/VerifyEmailPage";
import MembershipPage from "@/pages/MembershipPage";
import AdultPage from "@/pages/AdultPage";
import { ForgotPasswordPage, ResetPasswordPage } from "@/pages/PasswordPages";

const ProtectedRoute = ({ children }) => {
  const { user } = useAuth();
  if (user === null) return <main className="max-w-4xl mx-auto px-4 py-24 text-center text-slate-400">Loading…</main>;
  if (user === false) return <Navigate to="/login" replace />;
  return children;
};

function App() {
  return (
    <div className="App min-h-screen bg-slate-50 text-slate-900">
      <CompareProvider>
        <AuthProvider>
        <BrowserRouter>
          <Header />
          <Routes>
            <Route path="/" element={<HomePage />} />
            <Route path="/programs" element={<DirectoryPage />} />
            <Route path="/programs/:slug" element={<ProgramDetailPage />} />
            <Route path="/compare" element={<ComparePage />} />
            <Route path="/niches" element={<NichesPage />} />
            <Route path="/niches/:slug" element={<NicheDetailPage />} />
            <Route path="/beginners" element={<BeginnersHubPage />} />
            <Route path="/calculators" element={<CalculatorsPage />} />
            <Route path="/about" element={<AboutPage />} />
            <Route path="/admin" element={<AdminPage />} />
            <Route path="/adcp" element={<AdcpPage />} />
            <Route path="/get-featured" element={<GetFeaturedPage />} />
            <Route path="/payment/success" element={<PaymentSuccessPage />} />
            <Route path="/payment/cancel" element={<PaymentCancelPage />} />
            <Route path="/rewards" element={<RewardsPage />} />
            <Route path="/login" element={<LoginPage />} />
            <Route path="/signup" element={<SignupPage />} />
            <Route path="/verify-email" element={<VerifyEmailPage />} />
            <Route path="/membership" element={<MembershipPage />} />
            <Route path="/adult" element={<ProtectedRoute><AdultPage /></ProtectedRoute>} />
            <Route path="/forgot-password" element={<ForgotPasswordPage />} />
            <Route path="/reset-password" element={<ResetPasswordPage />} />
            <Route path="/dashboard" element={<ProtectedRoute><DashboardPage /></ProtectedRoute>} />
            <Route path="/ads" element={<ProtectedRoute><AdsPage /></ProtectedRoute>} />
            <Route path="/tutorials" element={<ProtectedRoute><TutorialsPage /></ProtectedRoute>} />
            <Route path="/leaderboard" element={<LeaderboardPage />} />
            <Route path="/official-links" element={<OfficialLinksPage />} />
            <Route path="/official-links/:slug" element={<OfficialLinkDetailPage />} />
            <Route path="/go/:handle" element={<RedirectPage />} />
            <Route path="/go/:handle/:slug" element={<RedirectPage />} />
          </Routes>
          <Footer />
        </BrowserRouter>
        </AuthProvider>
        <Toaster position="bottom-right" richColors />
      </CompareProvider>
    </div>
  );
}

export default App;
